import { render } from "./LojasAtivas.vue?vue&type=template&id=10b0e10c&scoped=true"
import script from "./LojasAtivas.vue?vue&type=script&lang=js"
export * from "./LojasAtivas.vue?vue&type=script&lang=js"

import "./LojasAtivas.vue?vue&type=style&index=0&id=10b0e10c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-10b0e10c"

export default script